exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n*[data-v-94647aee] {\n    position: absolute;\n}\n[data-v-94647aee]:not(.draggable) {\n    /* Prevent our cursor from tricking the user into thinking the element is draggable */\n    cursor: auto !important;\n}\n", ""]);

